import Router from 'vue-router';
import Vue from 'vue';
Vue.use(Router);
import routes from './Routes';
const router = new Router({ routes: routes });
export default router;
